/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRMIntegrationType = {
    SalesForce: 'SalesForce',
    Custom: 'Custom'
} as const;
export type CRMIntegrationType = typeof CRMIntegrationType[keyof typeof CRMIntegrationType];


export function CRMIntegrationTypeFromJSON(json: any): CRMIntegrationType {
    return CRMIntegrationTypeFromJSONTyped(json, false);
}

export function CRMIntegrationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRMIntegrationType {
    return json as CRMIntegrationType;
}

export function CRMIntegrationTypeToJSON(value?: CRMIntegrationType | null): any {
    return value as any;
}

